module.exports = __webpack_public_path__ + "img/depmap_svg_V75.15e4dee1.svg";